export class Base {
    id: number;
    createdDate: string;
    modifiedDate: string;
    createdById: string;
    modifiedById: string;
}